import { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

const AdminUserPage = lazy(() => import("./admin-user/AdminUserPage"));
const AdminGroupPage = lazy(() => import("./admin-group/AdminGroupPage"));
const DashboardPage = lazy(() => import("./dashboard/DashboardPage"));
const SetoresPage = lazy(() => import("./setores/SetoresPage"));
const DesafiosPage = lazy(() => import("./desafios/DesafiosPage"));
const ColaboradoresPage = lazy(() => import("./colaboradores/ColaboradoresPage"));
const ConfiguracoesPage = lazy(() => import("./configuracoes/ConfiguracoesPage"));

export default function HomePage() {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<Redirect exact from="/" to="/dashboard" />

				<Route path="/dashboard" component={DashboardPage} />
				<Route path='/setores' component={SetoresPage} />
				<Route path='/desafios' component={DesafiosPage} />
				<Route path='/colaboradores' component={ColaboradoresPage} />
				<Route path='/configuracoes' component={ConfiguracoesPage} />

				<Redirect to="/error/error-v6" />
			</Switch>
		</Suspense>
	);
}
